import React from 'react';

import { Box, CircularProgress } from '@mui/material';

import { Button } from '@/components/NewUI/ComponentsLibrary';

import { classes } from './styles';
import { GREY } from '../../../ThemeContext/constants';

import type { SxProps } from '@mui/material';

const ModalFooterButtons = ({
  primaryButtonText,
  primaryButtonID,
  primaryButtonCallback,
  primaryButtonMinWidth,
  primaryButtonDisabled,
  secondaryButtonText,
  secondaryButtonID,
  secondaryButtonCallback,
  secondaryButtonMinWidth,
  isLoading,
  stylesOverride,
  primaryButtonSx,
  secondaryButtonSx,
  primaryButtonDataTestId
}: {
  primaryButtonText?: string | React.JSX.Element;
  primaryButtonID?: string;
  primaryButtonCallback?: () => void;
  primaryButtonMinWidth?: string;
  primaryButtonDisabled?: boolean;
  secondaryButtonText?: string | React.JSX.Element;
  secondaryButtonID?: string;
  secondaryButtonCallback?: () => void;
  secondaryButtonMinWidth?: string;
  isLoading?: boolean;
  stylesOverride?: React.CSSProperties;
  primaryButtonSx?: SxProps;
  secondaryButtonSx?: SxProps;
  primaryButtonDataTestId?: string;
}) => (
  <Box sx={{ ...classes.modalFooter, ...stylesOverride }}>
    {secondaryButtonText ? (
      <Button
        buttonColor="red"
        buttonVariant="text"
        id={secondaryButtonID ?? 'secondary-modal-button'}
        onClick={secondaryButtonCallback ?? undefined}
        sx={
          secondaryButtonSx ?? {
            ...(secondaryButtonMinWidth && { minWidth: secondaryButtonMinWidth })
          }
        }
      >
        {secondaryButtonText}
      </Button>
    ) : null}
    {primaryButtonText ? (
      <Button
        buttonVariant="primary"
        data-testid={primaryButtonDataTestId}
        disabled={primaryButtonDisabled}
        id={primaryButtonID ?? 'primary-modal-button'}
        onClick={primaryButtonCallback ?? undefined}
        sx={{
          ...(primaryButtonMinWidth && { minWidth: primaryButtonMinWidth }),
          '&.Mui-disabled': { background: '#E5E5E5', color: GREY },
          ...primaryButtonSx
        }}
      >
        {isLoading ? <CircularProgress color="inherit" size={20} /> : primaryButtonText}
      </Button>
    ) : null}
  </Box>
);

export default ModalFooterButtons;
